<template>
  <div class="data-table-page">
    <div style="font-size: 18px;text-align: left; margin-bottom: 12px; border-bottom: 2px solid gray; padding: 12px 0">
      数据介绍：碳卫星甲烷数据，包括了从1970年到2022年中国的甲烷排放数据，按照
      经纬度的方式给出某一个特定坐标在特定年份的甲烷排放量。
    </div>
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="id"
            label="数据ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="year"
            label="年份">
          </el-table-column>
          <el-table-column
            align="center"
            prop="latitude"
            label="纬度">
          </el-table-column>
          <el-table-column
            align="center"
            prop="longitude"
            label="经度">
          </el-table-column>
          <el-table-column
            align="center"
            prop="emission"
            label="排放量">
          </el-table-column>
          <el-table-column
            align="center"
            width="310px"
            prop="digest"
            label="数据摘要">
          </el-table-column>
          <el-table-column
            align="center"
            width="200px"
            prop="blockTime"
            label="区块时间">
          </el-table-column>

        </el-table>

        <el-pagination
          @current-change="fetchList"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="totalNum">
        </el-pagination>

    <div style="text-align: right;font-size: 15px;margin-top: 0">
      数据来源：{{source}}<br>
      合约地址：0xd8e96cf08a54ac71ed5516d0497aa1df96c7bbc8 <br>
      分页接口：http://47.106.246.157:34568/ch4/evidence/page?cur=1&size=10
    </div>
      </div>

</template>

<script>

export default {
  data() {
    return {
      currentPage: 1,
      tableData: [],
      totalNum: 10,
      source: "https://edgar.jrc.ec.europa.eu/gallery?release=v80ghg&substance=CH4&sector=TOTALS"
    }
  },
  components: {},
  computed: {},

  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$http(null, '/data/ch4/evidence/page', {
        cur: this.currentPage++,
        size: 10
      }, 'get').then(res => {
        this.tableData = res.records
        this.currentPage = res.current
        this.totalNum = res.total
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.data-table-page::v-deep {
  padding: 20px;

  .el-table, .el-table__expanded-cell, .el-table tr, .el-table .el-table__expanded-cell, .el-table th.el-table__cell{
    background: transparent;
  }

  .el-table, .el-table thead {
    color: #fff;
  }



  .el-table__body {
    tr:hover>td{
      color: rgba(29, 35, 47, 1);
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination button:disabled, .el-pager li, .el-pagination .btn-next, .el-pagination .btn-prev{
    background: transparent;
    color: #fff;
  }

  .el-pager li.active {
    background: #fff;
    color: rgba(29, 35, 47, 1);
  }

}

.layout-container {
  height: 100vh;

  .el-aside {
    background-color: #232323;

    .el-menu {
      border-right: none;

    }
  }


}

</style>
